module.exports = __webpack_public_path__ + "static/media/send.f7d84495.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/send.svg
// module id = 1730
// module chunks = 0